let items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");
for (const item of items) {
    let closeTimer;
    item.addEventListener("mouseover", () => {
        clearTimeout(closeTimer);
        item.setAttribute("open", true);
    });
    item.addEventListener("mouseleave", () => {
        closeTimer = setTimeout(() => {
            item.removeAttribute("open");
        }, 150);
    });
}
